import React, { useEffect, useState } from "react";
import style from "./PracticeList.module.css";
import leftArrow from "../../assests/left arrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurl } from "../Url";
import { useSelector } from "react-redux";
import level from "../../assests/level.svg";
import calendar from "../../assests/calendar.svg";
import question from "../../assests/question_icon.png";
import clock from "../../assests/Clock.svg";
import fav from "../../assests/favorite_icon.png";
import range from "../../assests/Rectangle.svg";
import { IoClose } from "react-icons/io5";
import { Alert, Snackbar } from "@mui/material";

function PracticeList() {
  const { userDetails, status: userStatus } = useSelector(
    (state) => state.user
  );
  console.log("userDetails", userDetails);
  // console.log(userDetails._id.$oid);

  const location = useLocation();
  const { 
    pageNum, 
    title, 
    uniqueId, 
    aiId, 
    main_topic_id, 
    topic_id,
    singleTopic,
    learning,
    mapped,
    mainId,
    topic_no,
    userID,
    orgID,
    fromSubTopic,
    fromNewLearningDetail,
    expandedModuleIndices,
    scrollToPageNum,
    scrollToUniqueId,
    scrollToModuleIndex,
  } = location.state || {};

  // Debug logs
  console.log("PracticeList location.state:", location.state);
  console.log("fromSubTopic:", fromSubTopic);
  console.log("fromNewLearningDetail:", fromNewLearningDetail);

  const [storeskillListings, setstoreskillListings] = useState([]);
  console.log(storeskillListings);

  const isTrialUser = userDetails?.user_type === "Trail";
  const TRIAL_SKILL_LIMIT = 1;
  const isTrialSkillLocked = (skillIndex) =>
    isTrialUser && skillIndex >= TRIAL_SKILL_LIMIT;

  // console.log(pageNum, title, uniqueId);

  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [lastAssessmentData, setLastAssessmentData] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [snack, setSnack] = useState({ open: false, message: "" });
  const hasActiveSession = Boolean(lastAssessmentData?.session_status);

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  const fetchSkillListings = async () => {
    if (!aiId || !uniqueId) return;
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    console.log(token);
    console.log(uniqueId);
    console.log(aiId);
    console.log(userId);

    if (token) {
      try {
        const response = await fetch(`${baseurl}/practiceskills/map`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            unique_id: uniqueId,
            ai_id: aiId,
            user_id: userId,
            search_value: "",
          }),
        });

        // if (!response) {
        //   throw new Error("Network response was not ok");
        // }
        if (response) {
          const data = await response.json();
          // console.log(data);
          const list = data?.data;
          setstoreskillListings(Array.isArray(list) ? list : []);
          return data;
        }
      } catch (error) {
        console.error("Error fetching skill listings:", error);
      }
    }
  };

  const assessementpendingCheck = async (skillData) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    const ORG_id = localStorage.getItem("ORGID");

    if (token) {
      try {
        const response = await fetch(`${baseurl}/practice/active-session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            User_ID: userId,
            main_topic_id: main_topic_id,
            topic_id: topic_id,
            ai_id: aiId,
            mapped_skills: [
              {
                label: skillData.skill_name,
                skill_id: skillData.skill_id,
                skill_name: skillData.skill_name,
                value: skillData.skill_id,
              },
            ],
          }),
        });

        if (response.ok) {
          const data = await response.json();
          return data;
        }
      } catch (error) {
        console.error("Error checking active session:", error);
        throw error;
      }
    }
  };

  const handleSkillClick = async (skill, skillIndex) => {
    if (skill?.can_attend === false) {
      setSnack({ open: true, message: "subscribe for attend more practice test" });
      return;
    }
    if (isTrialSkillLocked(skillIndex)) return;
    try {
      const skillData = {
        skill_id: skill?.skill_id || skill?.value || "",
        skill_name: skill?.skill_name || skill?.label || "",
        value: skill?.value || skill?.skill_id || "",
      };

      const assessmentData = await assessementpendingCheck(skillData);
      setSelectedSkill(skillData);
      setLastAssessmentData(assessmentData);
      const hasActiveSession = Boolean(assessmentData?.session_status);
      setPopupText(
        hasActiveSession
          ? "Do you want to continue with your paused assessment?"
          : "Are you sure you want to start a practice session?"
      );
      setShowPopup(true);
    } catch (error) {
      console.error("Error in assessment flow:", error);
    }
  };

  const handlePopupYes = () => {
    navigate("/practice", {
      state: {
        ai_id: aiId,
        main_topic_id: main_topic_id,
        topic_id: topic_id,
        topic_name: title,
        subtopic_title_md: title,
        subtopic_index_md: pageNum,
        skill_id: selectedSkill?.skill_id,
        skill_name: selectedSkill?.skill_name,
        value: selectedSkill?.value,
        continue: true,
        page_reload: true,
        // Pass all data needed to navigate back to /skill/list
        pageNum,
        title,
        uniqueId,
        singleTopic,
        learning,
        mapped,
        mainId,
        topic_no,
        userID,
        orgID,
        fromNewLearningDetail,
        fromSubTopic,
        expandedModuleIndices,
        scrollToPageNum: scrollToPageNum ?? pageNum,
        scrollToUniqueId: scrollToUniqueId ?? uniqueId,
        scrollToModuleIndex,
      },
    });
    setShowPopup(false);
  };

  const handlePopupNo = () => {
    const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    if (lastAssessmentData?.is_trial_user === true) {
      setShowPopup(false);
      return;
    }
    if (hasActiveSession) {
      navigate("/practice", {
        state: {
          ai_id: aiId,
          main_topic_id: main_topic_id,
          topic_id: topic_id,
          topic_name: title,
          subtopic_title: title,
          subtopic_index: pageNum,
          skill_id: selectedSkill?.skill_id,
          skill_name: selectedSkill?.skill_name,
          value: selectedSkill?.value,
          continue: false,
          page_reload: true,
          // Pass all data needed to navigate back to /skill/list
          pageNum,
          title,
          uniqueId,
          singleTopic,
          learning,
          mapped,
          mainId,
          topic_no,
          userID,
          orgID,
          fromNewLearningDetail,
          fromSubTopic,
          expandedModuleIndices,
          scrollToPageNum: scrollToPageNum ?? pageNum,
          scrollToUniqueId: scrollToUniqueId ?? uniqueId,
          scrollToModuleIndex,
        },
      });
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
  };

  useEffect(() => {
    if (aiId && uniqueId) {
      fetchSkillListings();
    } else {
      setstoreskillListings([]);
      navigate("/new/learnings", { replace: true });
    }
  }, []);

  return (
    <div className={style.Container}>
      <div className={style.topicHeader}>
        <img
          src={leftArrow}
          className={style.backButton}
          alt="left arrow"
          onClick={() => {
            console.log("Back button clicked - fromSubTopic:", fromSubTopic, "fromNewLearningDetail:", fromNewLearningDetail);
            if (fromSubTopic) {
              console.log("Navigating to /tab");
              navigate("/new/learnings", {
                state: {
                  scrollToTabSection: true,
                  initialSkillsTab: "all-skills",
                  expandedModuleIndices,
                },
              });
            } else if (fromNewLearningDetail) {
              console.log("Navigating to /new/learnings/detail");
              navigate("/new/learnings/detail", {
                state: {
                  singleTopic,
                  learning,
                  mapped,
                  mainId,
                  topic_no,
                  userID,
                  orgID,
                  expandedModuleIndices,
                  scrollToPageNum: scrollToPageNum ?? pageNum,
                  scrollToUniqueId: scrollToUniqueId ?? uniqueId,
                  scrollToModuleIndex,
                }
              });
            } else {
              console.log("Using default navigate(-1)");
              navigate(-1);
            }
          }}
        />
        <div className={style.headingP}>
          <p className={style.subtopicHP}>Subtopic {pageNum} - Practice</p>
          <p className={style.subtopicHeadingP}>{title}</p>
        </div>
      </div>
      <div className={style.subTopicsDiv}>
        {Array.isArray(storeskillListings) &&
        storeskillListings.length > 0 &&
        storeskillListings
          .map((skills, index) => {
            // If last_attended is null, show subTopics
            if (skills.last_attended === null) {
              const isLocked = isTrialSkillLocked(index);
              return (
                <div
                  key={skills?.skill_id}
                  className={`${style.subTopics} ${isLocked ? style.disabledCard : ""}`}
                  id={skills?.skill_id}
                  onClick={() => handleSkillClick(skills, index)}
                >
                  <p className={style.subtopicP}>Skill {index + 1}</p>
                  <span className={style.subtopicSpan}>{skills?.skill_name}</span>
                </div>
              );
            } else {
              // If last_attended has value, show greenCard
              const formatDate = (dateString) => {
                const date = new Date(dateString);
                return date.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                });
              };

              const formatTime = (seconds) => {
                const hrs = Math.floor(seconds / 3600);
                const mins = Math.floor((seconds % 3600) / 60);
                const secs = seconds % 60;
                            
                if (hrs > 0) {
                  return `${hrs}:${mins.toString().padStart(2, '0')}:${secs
                    .toString()
                    .padStart(2, '0')}`;
                } else {
                  return `${mins}:${secs.toString().padStart(2, '0')}`;
                }
              };

              const calculateProficiency = (score, threshold) => {
                if (threshold === 0) return 0;
                const percentage = (score / threshold) * 100;
                return Math.min(Math.floor(percentage / 20), 5); // Max 5 levels
              };

              const proficiencyLevel = calculateProficiency(skills.total_mark_scored, skills.threshold_marks);
              const percentage= skills?.threshold_marks ? Math.min(100,Math.round((skills?.total_mark_scored / skills?.threshold_marks) * 100)) : 0;
              const isLocked = isTrialSkillLocked(index);

              return (
                <div
                  key={skills?.skill_id}
                     className={
                    `${style.greenCard} ` +
                    (
                      percentage !== null && percentage !== undefined
                        ? percentage > 85
                          ? style.greenComplete   
                          : percentage > 40
                            ? style.yellowCard     
                            : style.redCard        
                        : style.complete           
                    ) +
                    (isLocked ? ` ${style.disabledCard}` : "")
                  }

                  onClick={() => handleSkillClick(skills, index)}
                >
                  <div className={style.wholeWrapper}>
                    <div className={style.skillWrapp}>
                      <p>Skill {index + 1}</p>
                    </div>
                    <div className={style.mainContainer}>
                      <p className={style.understandPara}>
                        {skills?.skill_name}
                      </p>
                      <div className={style.detailsWrapper}>
                        <div className={style.MiniWrapper}>
                          <div className={style.proWrapper}>
                            <p>Practice level</p> <img src={level} alt="" />
                          </div>
                          <div className={style.rangeContainer}>
                            {[...Array(5)].map((_, i) => (
                              <img 
                                key={i} 
                                src={range} 
                                alt="" 
                                style={{ 
                                  opacity: i < proficiencyLevel ? 1 : 0.3 
                                }} 
                              />
                            ))}
                          </div>
                        </div>
                        <div className={style.MiniWrapper}>
                          <div className={style.proWrapper}>
                            <p>Last Practiced</p>{" "}
                            <img src={calendar} alt="" />
                          </div>
                          <div className={style.DateContainer}>
                            <p>{formatDate(skills.last_attended)}</p>
                          </div>
                        </div>
                        <div className={style.MiniWrapper}>
                          <div className={style.proWrapper}>
                            <p>Answered</p> <img src={question} alt="" />
                          </div>
                          <div className={style.DateContainer}>
                            <p>{skills.questions_attended}</p>
                          </div>
                        </div>
                        <div className={style.MiniWrapper}>
                          <div className={style.proWrapper}>
                            <p>Time Spent</p> <img src={clock} alt="" />
                          </div>
                          <div className={style.DateContainer}>
                            <p>{formatTime(skills.total_time_taken)}</p>
                          </div>
                        </div>
                        <div className={style.MiniWrapper}>
                          <div className={style.proWrapper}>
                            <p>Proficiency</p> <img src={fav} alt="" />
                          </div>
                          <div className={style.DateContainer}>
                            <p>{percentage} %</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          })}
      </div>

      {showPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            {hasActiveSession && (
              <button
                type="button"
                className={style.popupCloseButton}
                onClick={handlePopupClose}
                aria-label="Close"
              >
                <IoClose />
              </button>
            )}
            <div className={style.popupText}>
              <p style={{textAlign:"center"}}>{popupText}</p>
              {hasActiveSession && (
                <div><span>
                  You paused on the practice test sub-topic</span>
                  <div className={style.subtopicTitle}>{title}</div>
                </div>
              )}
            </div>
            <div className={style.PopupButton}>
              <button className={style.noButton} onClick={handlePopupNo}>
                {hasActiveSession
                  ? lastAssessmentData?.is_trial_user === true
                    ? "Cancel"
                    : "No, start again please"
                  : "No"}
              </button>
              <button className={style.yesButton} onClick={handlePopupYes}>
                {hasActiveSession ? "Yes" : "Yes"}
              </button>
            </div>
          </div>
        </>
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ open: false, message: "" })}
      >
        <Alert
          severity="warning"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
          onClose={() => setSnack({ open: false, message: "" })}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default PracticeList;
